angular.module('core')
    .filter('trustedTranslate', ['translateFilter', '$sce', function(translateFilter, $sce) {
        return function(key, interpolateParams) {
            var translated = translateFilter(key, interpolateParams);
            return $sce.trustAsHtml(translated);
        };
    }]);
